import React from 'react';
import '../less/installment_from_statement.less';
import hero_img from '../img/inst_from_statement/hero_img.png';
import additional_product_img_1 from '../img/inst_from_statement/additional_product_img_1.png';
import additional_product_img_2 from '../img/inst_from_statement/additional_product_img_2.png';
import AdditionalProduct from './../../../auxiliary-components/shared/AdditionalProductBlock';
import QuestionsAdminNew from './../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "./../../../auxiliary-components/shared/FilesForDownloadNew";
import TextAboveFooterNew from "./../../../auxiliary-components/shared/TextAboveFooterNew";
import FAQStorybook from '@abank/abank-faq';
import Tabs from './../../../auxiliary-components/shared/Tabs';
import Tariffs from './../../../auxiliary-components/shared/TariffsBlock';
import HowToBlockNew from './../../../auxiliary-components/shared/HowToBlockNew';
import how_to_block_img_1 from '../img/inst_from_statement/how_to_block_1.png';
import how_to_block_img_2 from '../img/inst_from_statement/how_to_block_2.png';
import how_to_block_img_3 from '../img/inst_from_statement/how_to_block_3.png';
import how_to_block_img_4 from '../img/inst_from_statement/how_to_block_4.png';
import Hero from './../../../auxiliary-components/shared/HeroBlock';
import Advantages from '../../../auxiliary-components/shared/AdvantagesBlock';
import CalculatorNew from '../../../auxiliary-components/CalculatorNew';
import { Preloader } from 'MWComponents';
import { filterByEnvironment } from '../../../helpers/utils/environmentFilter';

export default function template() {
    const model = this.getModel();
    const page = 'installment-from-statement-redesign';

    const tabs = [{tab: 'get-services', title: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_TABS_TITLE_01'},
          {tab: 'calculator', title: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_TABS_TITLE_02'},
          {tab: 'payments', title: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_TABS_TITLE_03'}];

    const hero_data = {
      title: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_HERO_TITLE',
      text: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_HERO_TEXT',
      link: {
        text: "INSTALLMENT_FROM_STATEMENT_REDESIGN_HERO_BTN",
        onClick: () => window.open("/services/abank", "_self"),
      }
    };

    const additionalCards = [
      {
        img: additional_product_img_1,
        link: '/cards/green',
        title: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_ADDITIONAL_PRODUCT_TITLE_01',
        text: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_ADDITIONAL_PRODUCT_TEXT_01',
        textBtn: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_ADDITIONAL_PRODUCT_LINK_01',
      },
      {
        img: additional_product_img_2,
        link: '/cards/atb',
        title: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_ADDITIONAL_PRODUCT_TITLE_02',
        text: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_ADDITIONAL_PRODUCT_TEXT_02',
        textBtn: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_ADDITIONAL_PRODUCT_LINK_02',
      }
    ];

    const tariffsData = [
      {
        label: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_TARIFFS_CELL_1_1',
        value: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_TARIFFS_CELL_1_2',
      },
      {
        label: "INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_TARIFFS_CELL_2_1",
        value: "INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_TARIFFS_CELL_2_2",
      },
      {
        label: "INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_TARIFFS_CELL_3_1",
        value: "INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_TARIFFS_CELL_3_2",
      },
      {
        label: "INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_TARIFFS_CELL_4_1",
        value: "INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_TARIFFS_CELL_4_2",
      },
    ];

    const howToBlockItems = [
      {
        img: how_to_block_img_1,
        title: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_HOW_TO_TITLE_01',
        text: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_HOW_TO_TEXT_01',
      },
      {
        img: how_to_block_img_2,
        title: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_HOW_TO_TITLE_02',
        text: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_HOW_TO_TEXT_02',
      },
      {
        img: how_to_block_img_3,
        title: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_HOW_TO_TITLE_03',
        text: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_HOW_TO_TEXT_03',
      },
      {
        img: how_to_block_img_4,
        title: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_HOW_TO_TITLE_04',
        text: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_HOW_TO_TEXT_04',
      }
    ];

    const advantagesItems = [
      {
        title: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_ADVANTAGES_TITLE_01',
        text: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_ADVANTAGES_TEXT_01',
      },
      {
        title: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_ADVANTAGES_TITLE_02',
        text: 'INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_ADVANTAGES_TEXT_02',
      }
    ];

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
        <div className="installment-from-statement-redesign">
          <Hero
            data={hero_data}
            img={hero_img}
            page={page}
            imgBottom
          />
          <div className="content">
            {!this.state.faqTab ? (
              <>
                <Tariffs
                  alignItems="start"
                  items={tariffsData}
                  title={'INSTALLMENT_FROM_STATEMENT_REDESIGN_CARDS_TARIFFS_TITLE'}
                />
                <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} page={page}>
                  <HowToBlockNew
                    items={howToBlockItems}
                  />
                  {model.creditSum ? (
                    <CalculatorNew model={model} type={"installment_from_statement"} {...this.props} tab={this.state.tab}/>
                  ) : <Preloader />}
                  <Advantages
                    items={advantagesItems}
                  />
                </Tabs>
                <AdditionalProduct
                  items={additionalCards}
                  title={'INSTALLMENT_FROM_STATEMENT_REDESIGN_ADDITIONAL_PRODUCT_TITLE'}
                  page={page}
                />
                <QuestionsAdminNew
                  widget={questionsWidget}
                  toggleFaqTab={this.toggleFaqTab}
                  title={'FAQ_SHORT_NEW_TITLE'}
                  page={page}
                />
                <FilesForDownloadNew
                  widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
                />
                <TextAboveFooterNew
                  widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
                />
              </>
            ) : (
              <FAQStorybook
                widget={questionsWidget}
                title={this.l10n('INSTALLMENT_FROM_STATEMENT_REDESIGN_FAQ_STORYBOOK_TITLE')}
                btnText={this.l10n('INSTALLMENT_FROM_STATEMENT_REDESIGN_FAQ_STORYBOOK_BTN_TEXT')}
                onBtnClick={this.toggleFaqTab}
                filterByEnvironment={filterByEnvironment}
              />
            )}
          </div>
        </div>
    );
}
